import { ICoreContext, getUrlSync } from '@msdyn365-commerce/core';

function normalizeUrlPathname(pathname: string): string {
    return pathname.replace(/^\/+|\/+$/g, '');
}

export function isOnHomePage(context: ICoreContext): boolean {
    const homeUrlString = getUrlSync('home', context.actionContext);

    if (!homeUrlString) {
        return false;
    }

    const homeUrl = new URL(homeUrlString, context.request.url.requestUrl.origin);
    const currentUrl = context.request.url.requestUrl;

    if (homeUrl.origin.toLowerCase() === currentUrl.origin.toLowerCase() &&
        normalizeUrlPathname(homeUrl.pathname).toLowerCase() === normalizeUrlPathname(currentUrl.pathname).toLowerCase()
    ) {
        return true;
    }
    return false;
}
